import { PostgrestSingleResponse, SupabaseClient } from '@supabase/supabase-js';

const table = 'device';

export interface DeviceDto {
  id: number;
  name: string;
  tournament_id: number;
  created_at: string;
}

export default class Device {
  constructor(private supabase: SupabaseClient) {}

  public async create(params: { name: string; tournament_id: number }) {
    const { data, error } = (await this.supabase
      .from(table)
      .insert(params)
      .select()
      .single()) as PostgrestSingleResponse<DeviceDto>;

    if (error) {
      console.error(error);
      throw error;
    }

    return data;
  }

  public async update(id: number, params: Partial<{ name: string; tournament_id: number }>) {
    const { data, error } = (await this.supabase
      .from(table)
      .update(params)
      .eq('id', id)
      .select()
      .single()) as PostgrestSingleResponse<DeviceDto>;

    if (error) {
      console.error(error);
      throw error;
    }

    return data;
  }

  public async delete(id: number) {
    const { error } = await this.supabase.from(table).delete().eq('id', id);

    if (error) {
      console.error(error);
      throw error;
    }

    return true;
  }

  public async list(params: { tournament_id: number; offset?: number; limit?: number; name?: string }) {
    let query = this.supabase
      .from(table)
      .select('*')
      .eq('tournament_id', params.tournament_id)
      .order('created_at', { ascending: false });

    if (params.name) {
      query = query.ilike('name', `%${params.name}%`);
    }
    if (params.offset !== undefined) {
      query = query.range(params.offset, params.offset + (params.limit ?? 20) - 1);
    }

    const { data, error } = await query;

    if (error) {
      console.error(error);
      throw error;
    }

    return data as DeviceDto[];
  }
}
